import { useSelector } from 'react-redux';

import type { EligibilityCoupon } from '@/domains/loyalty/modules/CouponEligibility/interfaces/EligibilityCoupon';
import { SpartacuxProB2BAnimationState } from '@/domains/proB2BAnimation/store/proB2BAnimation.model';

import { eligibilityCoupon } from '../eligibilityCoupons.selectors';

export const eligibilityCouponSelector = (
  state: Partial<SpartacuxProB2BAnimationState>,
): EligibilityCoupon | undefined =>
  state?.proB2BAnimation?.eligibilityCoupon?.eligibilityCoupon;

export const useEligibilityCoupon = () => useSelector(eligibilityCoupon) || {};
